import type { HeldCallsCollapsibleProps } from './index.types';
import { ReactComponent as OnHoldIcon } from 'Assets/icons/on-hold.svg';
import { SoftphoneCollapsibleItems } from 'Modules/softphone/components/SoftphoneCollapsibleItems';
import React from 'react';
import { HeldCallItem } from '../HeldCallItem';

/**
 * HeldCallsCollapsible - Displays multiple calls on hold with expandable dropdown.
 *
 * Thin wrapper around SoftphoneCollapsibleCallGroup that maps held-call-specific
 * props to the generic collapsible interface.
 */
export const HeldCallsCollapsible = ({
  calls,
  isExpanded,
  onToggle,
  closeCollapsible,
  onCallClick,
  nonSwappableCallId,
  boundaryRef,
  testID,
}: HeldCallsCollapsibleProps): React.ReactElement => {
  const numberOfHeldCalls = calls.length;
  const title = `${numberOfHeldCalls} ${
    numberOfHeldCalls === 1 ? 'call' : 'calls'
  }`;

  return (
    <SoftphoneCollapsibleItems
      title={title}
      subtitle="on hold"
      icon={OnHoldIcon}
      isExpanded={isExpanded}
      onToggle={onToggle}
      closeCollapsible={closeCollapsible}
      boundaryRef={boundaryRef}
      listAriaLabel="Calls on hold"
      itemCount={calls.length}
      onItemSelect={(index) => {
        const call = calls[index];
        if (call && call.id !== nonSwappableCallId) onCallClick(call.id);
      }}
      testID={testID}
    >
      {calls.map((call) => (
        <HeldCallItem
          key={call?.id}
          call={call}
          onClick={onCallClick}
          showTimer={true}
          showSwapIcon={call.id !== nonSwappableCallId}
          testID={testID}
        />
      ))}
    </SoftphoneCollapsibleItems>
  );
};

HeldCallsCollapsible.displayName = 'HeldCallsCollapsible';
